<style lang="scss">
  svg {
    fill: #3a3a3a;
    height: 20px;
    display: inline-block;
  }
</style>

<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M10 15.625C6.89813 15.625 4.375 13.1019 4.375 10C4.375 6.89813 6.89813 4.375 10 4.375C13.1019 4.375 15.625 6.89813 15.625 10C15.625 13.1019 13.1019 15.625 10 15.625ZM10 3.125C6.20937 3.125 3.125 6.20937 3.125 10C3.125 13.7906 6.20937 16.875 10 16.875C13.7906 16.875 16.875 13.7906 16.875 10C16.875 6.20937 13.7906 3.125 10 3.125ZM10.5258 9.11012H9.47519C9.41394 9.11012 9.38769 9.14512 9.38769 9.19763V13.0376C9.38769 13.0901 9.42269 13.1251 9.47519 13.1251H10.5258C10.5871 13.1251 10.6133 13.0901 10.6133 13.0376V9.19763C10.6133 9.13637 10.5783 9.11012 10.5258 9.11012ZM10.0006 6.734C9.61563 6.734 9.3 7.03213 9.3 7.41713C9.3 7.80212 9.61563 8.09963 10.0006 8.09963C10.3856 8.09963 10.7013 7.80212 10.7013 7.41713C10.7013 7.03213 10.3856 6.734 10.0006 6.734Z" fill="#3A3A3A"/>
</svg>
